// This is the parent component of a modal: ModalAdminpayments

import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GenericModal from "./GenericModal";
import ModalAdminpayments from "./ModalAdminpayments";
import ModalAdminpaymentsEdit from "./ModalAdminpaymentsedit";
import Navbar from "./Navbar";
import { fetchReferralpaymentsItems } from "./redux/slices/ReferralpaymentsThunks";
import { fetchReferralsItems } from "./redux/slices/ReferralsThunks";

export default function Adminpayments() {
  const dispatch = useDispatch();
  const payments = useSelector((state) => state.referralpayments.items);
  const referrals = useSelector((state) => state.referrals.items);
  const [referralIds, setReferralIds] = useState([]);
  const [showData, setShowData] = useState([]);
  const [allShowData, setAllShowData] = useState([]);
  const [tableColumn, setTableColumn] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  // Modal logic goes here for Adminpayments
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [active, setActive] = useState({});

  const openModal = () => setIsModalOpen(true);
  const closeModal = async () => {
    await getPayments();
    setIsModalOpen(false);
  };
  const openEditModal = () => {
    setIsEditModalOpen(true);
  };
  const closeEditModal = async () => {
    await getPayments();
    setIsEditModalOpen(false);
  };

  const editClick = (item) => {
    setActive(item);
    openEditModal();
  };

  useEffect(() => {
    if (allShowData.length > 0) {
      const filtered = allShowData.filter((val) =>
        val.email.toLowerCase()?.includes(search.toLowerCase())
      );

      setShowData(filtered);
    }
  }, [search, payments]);

  useEffect(() => {
    if (payments.length > 0) {
      const tableColumns = [
        { key: "date", width: "20%" },
        { key: "email", width: "20%" },
        { key: "referral_id", width: "20%" },
        { key: "reward", width: "20%" },
        { key: "payment_action", width: "20%" },
      ];

      const tableData =
        payments.length > 0
          ? payments.map((val, idx) => {
              return {
                _id: val?._id,
                date: val.payment_completed_at
                  ? val.payment_completed_at.split("T")[0]
                  : "",
                email: val.email_address ? val.email_address : "",
                referral_id: val.referral_id ? val.referral_id : "",
                reward: val.amount_paid
                  ? val.amount_paid
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : "",
              };
            })
          : [];
      setTableColumn(tableColumns);
      setShowData(tableData);
      setAllShowData(tableData);
    }
  }, [payments]);

  useEffect(() => {
    const getRefferalIds = () => {
      if (referrals.length > 0) {
        var arr = [];
        referrals.map((val, idx) => {
          var obj = {};
          obj.value = val.id;
          obj.label = val.id;
          arr.push(obj);
        });
        setReferralIds(arr);
      }
    };

    getRefferalIds();
  }, [referrals]);

  const getPayments = () => {
    try {
      dispatch(fetchReferralpaymentsItems());
      dispatch(fetchReferralsItems());
      const tableHeaders = [
        { label: "Payment Date", width: "20%" },
        { label: "Email", width: "20%" },
        { label: "Referral ID", width: "20%" },
        { label: "Reward", width: "20%" },
        { label: "Action", width: "20%" },
      ];
      setTableHeader(tableHeaders);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getPayments();
  }, []);

  return (
    <RootWrapperAdminpayments>
      <Navbar />
      <Dashboard>
        <Wrapper>
          <Left_0001>
            <PRTNR.SidebarNav />
          </Left_0001>
          <Right>
            <DashboardHeader>
              <Frame1462>
                <WelcomeJames>Payments</WelcomeJames>
              </Frame1462>
              <Frame1461>
                <AIMEButton
                  size="small"
                  onClick={() => openModal()}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    gap: "10px",
                    borderRadius: "48px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "16px 32px",
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "16px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "110%",
                      textAlign: "left",
                    }}
                  >
                    Add Payment
                  </span>
                </AIMEButton>
              </Frame1461>
            </DashboardHeader>
            <ContentBox>
              <TableTitle>
                <Frame1431>
                  <Title>All</Title>
                </Frame1431>
                <Frame1432>
                  <GFieldsStacked>
                    <GFieldsStacked_0001>
                      <PRTNR.Input
                        type="text"
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </GFieldsStacked_0001>
                  </GFieldsStacked>
                </Frame1432>
              </TableTitle>
              <PRTNR.TableComponent
                data={showData}
                tableColumn={tableColumn}
                tableHeader={tableHeader}
                editClick={editClick}
              />
            </ContentBox>
          </Right>
        </Wrapper>
      </Dashboard>
      <Footer>
        <Section>
          <Section_0001>
            <Wrapper_0001>
              <Frame38>
                <_2025PaartnerLimitedAllRightsReserved>
                  © 2025 Paartner Limited. All Rights Reserved
                </_2025PaartnerLimitedAllRightsReserved>
              </Frame38>
            </Wrapper_0001>
          </Section_0001>
        </Section>
      </Footer>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalAdminpayments
          isOpen={isModalOpen}
          onClose={closeModal}
          referrals={referralIds}
        />
      </GenericModal>
      <GenericModal isOpen={isEditModalOpen} onClose={closeEditModal}>
        <ModalAdminpaymentsEdit
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          referrals={referralIds}
          active={active}
        />
      </GenericModal>
    </RootWrapperAdminpayments>
  );
}

const RootWrapperAdminpayments = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 1200px;
  box-sizing: border-box;
  padding: 32px 0px;
`;

const Left_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  width: 298px;
  box-sizing: border-box;
`;

const Right = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 24px;
  width: 878px;
  box-sizing: border-box;
`;

const DashboardHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1462 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 692px;
  box-sizing: border-box;
`;

const WelcomeJames = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: center;
`;

const Frame1461 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const ContentBox = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const TableTitle = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1431 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Title = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1432 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 782px;
  box-sizing: border-box;
`;

const GFieldsStacked = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
`;

const GFieldsStacked_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 4px;
  box-sizing: border-box;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Section_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 60px;
  flex-shrink: 0;
`;

const Wrapper_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame38 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const _2025PaartnerLimitedAllRightsReserved = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
